import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const BillingCancelPage = () => {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="billing-cancel-page">
      <Card className="max-w-lg w-full text-center">
        <CardHeader>
          <div className="mx-auto h-16 w-16 rounded-full bg-muted flex items-center justify-center">
            <XCircle className="h-8 w-8 text-muted-foreground" />
          </div>
          <CardTitle>Payment cancelled</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-muted-foreground">
            No charge has been made.{orderId && ` (Order ${orderId})`}
          </p>
          <div className="flex gap-2 justify-center pt-2">
            <Button asChild data-testid="billing-cancel-back">
              <Link to="/pricing">Back to plans</Link>
            </Button>
            <Button asChild variant="outline" data-testid="billing-cancel-dashboard">
              <Link to="/dashboard">Continue free</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingCancelPage;
